import React from 'react';
import moment from 'moment';
import { Form } from 'react-bootstrap';
import { Button } from 'reactstrap';
import { getBlankValueIfNUll } from '../../utils/Util';
import { useNavigate } from 'react-router-dom';
import { LastLocationType } from '../../utils/Types';
import { useAppDispatch } from '../../store/redux-hooks';
import { onTaskClick } from './TrackLocationHelper';
import { DATE_FORMAT } from '../../utils/Constant';

export interface ITrackLocationHistoryProps {
  selectedDate?: string;
  activeDateNumber?: number;
  trackHistoryList: any[];
  showTollTip: (index: number) => void;
  onTrackingDateChange: (date: string, activeDateNumber: number) => void;
  lastLocation: LastLocationType;
}
const TrackLocationHistory = ({
  selectedDate,
  onTrackingDateChange,
  trackHistoryList,
  showTollTip,
  activeDateNumber,
  lastLocation,
}: ITrackLocationHistoryProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return (
    <div className="custom-map-modal-wrapper">
      <div className="d-flex justify-content-between">
        <Button
          variant="primary"
          type="button"
          className={`cl-btn-primary mt-2 custom-map-button ${
            activeDateNumber !== 1 && 'custom-map-button-inactive'
          }`}
          onClick={() => {
            onTrackingDateChange(
              moment(selectedDate).format(DATE_FORMAT.YYYY_MM_DD),
              1
            );
          }}
        >
          {moment(selectedDate).format('D MMM')}
        </Button>
        <Button
          variant="primary-outline"
          type="button"
          className={`mt-2 custom-map-button mx-1 ${
            activeDateNumber !== 2 && 'custom-map-button-inactive'
          }`}
          onClick={() => {
            onTrackingDateChange(
              moment(selectedDate)
                .subtract(1, 'days')
                .format(DATE_FORMAT.YYYY_MM_DD),
              2
            );
          }}
        >
          {moment(selectedDate).subtract(1, 'days').format('D MMM')}
        </Button>
        <Button
          variant="primary-outline"
          type="button"
          className={`mt-2 custom-map-button ${
            activeDateNumber !== 3 && 'custom-map-button-inactive'
          }`}
          onClick={() => {
            onTrackingDateChange(
              moment(selectedDate)
                .subtract(2, 'days')
                .format(DATE_FORMAT.YYYY_MM_DD),
              3
            );
          }}
        >
          {moment(selectedDate).subtract(2, 'days').format('D MMM')}
        </Button>
      </div>
      <div className="mt-4 custom-map-radio custom-map-radio-height">
        {trackHistoryList
          ?.slice()
          ?.reverse()
          ?.map((item, index) => {
            if (
              item?.referenceModuleName === 'Task' ||
              index === 0 ||
              index === trackHistoryList.length - 1
            ) {
              return (
                <div className="mb-1" key={`track-${item.locationReceivedAt}`}>
                  <Form.Check
                    inline
                    label={
                      <div className="location-log-header">
                        <strong>
                          {moment(item?.locationReceivedAt).format('h.mm A')}{' '}
                          {item.referenceModuleName === 'Logged'
                            ? '- Logged In'
                            : ''}
                        </strong>
                        <br />
                        <span>{item?.locationName ?? '-'}</span>
                        <br />
                        {item?.referenceId && (
                          <button
                            className="location-log-taskid button-container"
                            onKeyDown={() => {
                              onTaskClick(
                                item,
                                lastLocation,
                                selectedDate,
                                activeDateNumber,
                                dispatch,
                                navigate
                              );
                            }}
                            onClick={() => {
                              onTaskClick(
                                item,
                                lastLocation,
                                selectedDate,
                                activeDateNumber,
                                dispatch,
                                navigate
                              );
                            }}
                          >
                            Task Id - {item?.referenceId}{' '}
                            {getBlankValueIfNUll(item.referenceType)
                              ? `(${getBlankValueIfNUll(item.referenceType)})`
                              : ''}
                          </button>
                        )}
                      </div>
                    }
                    value="20"
                    name="group1"
                    type="radio"
                    id={`inline-radio-1`}
                    className="me-4 cl-label mb-2"
                    onChange={() => {
                      showTollTip(index);
                    }}
                  />
                </div>
              );
            }
          })}

        {!trackHistoryList?.length && (
          <span className="empty-logs-data">Data not found</span>
        )}
      </div>
    </div>
  );
};

export default TrackLocationHistory;
